module.exports = __webpack_public_path__ + "media/images/icons/dollar-08361a5222950b03d7edf348c537a79a.svg";